import React from 'react';

export default () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="22" height="24" viewBox="0 0 22 24">
    <g fill="none" fillRule="evenodd" stroke="#21EA9F" strokeWidth="1.5">
      <path d="M1 12.05l10 10 10-10M10.925 22.05V.2" />
    </g>
  </svg>
);
